import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { Box, Typography } from '@mui/material';
import loadingVideo from '../assets/BCL_Loading.mp4';
import './LoadingScreen.css';

const LoadingScreen = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.playbackRate = 1.5;
      
      // Attempt to play
      const attemptPlay = () => {
        const playPromise = video.play();
        
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            console.log('Autoplay prevented, will play on interaction:', error);
          });
        }
      };

      // Try to play immediately
      attemptPlay();

      // Also try on page visibility change (helps with iOS)
      const handleVisibilityChange = () => {
        if (!document.hidden && video.paused) {
          attemptPlay();
        }
      };

      document.addEventListener('visibilitychange', handleVisibilityChange);

      return () => {
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      };
    }
  }, []);

  return (
    <Box className="loading-screen">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="loading-content"
      >
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          webkit-playsinline="true"
          preload="auto"
          className="loading-video"
          style={{ width: '300px', height: '300px' }}
          tabIndex="-1"
          disablePictureInPicture
          controlsList="nodownload nofullscreen noremoteplayback"
        >
          <source src={loadingVideo} type="video/mp4" />
        </video>
        <Box className="loading-text" sx={{ flexDirection: 'column' }}>
          <Box>
            <Typography
              variant="h3"
              component="span"
              className="bio-text"
              style={{
                fontFamily: 'Quicksand, sans-serif',
                color: '#51A8B1',
                fontWeight: 700
              }}
            >
              BioCircuit
            </Typography>
            <Typography
              variant="h3"
              component="span"
              className="labs-text"
              style={{
                fontFamily: 'Barlow, sans-serif',
                color: '#A8CF45',
                fontWeight: 700,
                marginLeft: '10px'
              }}
            >
              LABS
            </Typography>
          </Box>
          <motion.div
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.35 }}
          >
            <Typography
              component="p"
              sx={{
                fontFamily: 'Barlow, sans-serif',
                color: '#A3AFB1',
                fontWeight: 600,
                fontSize: '0.78rem',
                letterSpacing: '0.28em',
                textTransform: 'uppercase',
                textAlign: 'center',
                marginTop: '6px',
              }}
            >
              AI Powered Systems
            </Typography>
          </motion.div>
        </Box>
      </motion.div>
    </Box>
  );
};

export default LoadingScreen;